<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="searchItem">
                            <el-select clearable v-model="activityUuid"
                                       @change="chooseActivityWayInfo"
                                       placeholder="活动名称">
                                <el-option
                                    v-for="item in activityList"
                                    :key="item.uuid"
                                    :label="item.activityName"
                                    :value="item.uuid">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-select clearable v-model="activityWayUuid"
                                       @change="getTypeInfo"
                                       placeholder="赛道名称">
                                <el-option
                                    v-for="item in activityWayList"
                                    :key="item.uuid"
                                    :label="item.name"
                                    :value="item.uuid">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-select clearable v-model="typeUuid" placeholder="作品分类">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.uuid"
                                    :label="item.worksType"
                                    :value="item.uuid">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="searchItem">
                            <el-input v-model="teamName" placeholder="单位/院校"></el-input>
                        </div>
                        <div class="searchItem">
                            <el-input v-model="worksName" placeholder="作品名称"></el-input>
                        </div>
                        <div class="searchItem">
                          <el-select clearable v-model="status" placeholder="审核状态">
                            <el-option
                              v-for="item in winType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>                          
                        </div>
                        <!--<div class="searchItem">
                            <el-date-picker
                                v-model="createDate"
                                type="date"
                                placeholder="报名时间"
                            >
                            </el-date-picker>
                        </div>-->
                        <div class="searchItem searchItem_time">
                            <el-date-picker
                                style="width:320px;"
                                @change="chooseDate"
                                v-model="createDate"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="上传开始日期"
                                end-placeholder="上传结束日期" class="datainput">
                            </el-date-picker>
                        </div>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <!-- <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>添加
                                </el-button>
                            </div>
                        </div> -->
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="activityName"
                                label="活动名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="activityWayName"
                                label="赛道名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="typeName"
                                label="作品分类"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="上传作品时间"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <!--<el-table-column
                                prop="username"
                                label="昵称"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip>
                            </el-table-column>-->
                            <el-table-column
                                prop="username"
                                label="姓名"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="tel"
                                align="center"
                                header-align="center"
                                label="联系方式">
                            </el-table-column>
                            <!--<el-table-column
                                prop="signType"
                                align="center"
                                header-align="center"
                                label="参赛主体">
                                <template slot-scope="scope">
                                    {{ scope.row.signType==='PERSONAL'?'个人':'团队' }}
                                </template>
                            </el-table-column>-->
                            <el-table-column
                                prop="teamName"
                                align="center"
                                header-align="center"
                                label="单位/院校">
                            </el-table-column>
                            <!--<el-table-column
                                prop="teamMember"
                                align="center"
                                header-align="center"
                                label="团队成员">
                            </el-table-column>-->
                            <el-table-column
                                prop="name"
                                align="center"
                                header-align="center"
                                label="作品名称">
                            </el-table-column>
                            <el-table-column
                                prop="statusCn"
                                align="center"
                                header-align="center"
                                label="审核状态">
                            </el-table-column>

                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.status==='SUBMIT'" @click="examineMess(scope.row.uuid,1)">审核</el-button>
                                    <el-button type="text" size="small" @click="examineMess(scope.row.uuid,2)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        
        <!--审核-->
        <examine-Mess-dialog ref="examineMessDialogRef" @submit="getList"></examine-Mess-dialog>
    </div>
</template>

<script>
    import { getWorksList,getActivityInfo,getActivityWayList,getActivityTypeList } from '../../utils/interface';
    import examineMessDialog from './activeDialog/examineMessDialog'
    export default {
        components: {examineMessDialog},
        data() {
            return {
                teamName: '',
                worksName:'',
                tableData: [],
                status:"",
                // 筛选
                winType: [
                    {
                        value:'PASS',
                        label:'审批通过',
                    },
                    {
                        value:'SUBMIT',
                        label:'审批中',
                    },
                    {
                        value:'REJECT',
                        label:'未通过',
                    },
                ],
                worksStatus: [
                    {
                        value:'1',
                        label:'个人',
                    },
                    {
                        value:'2',
                        label:'团队',
                    },
                ],
                screening: {
                    winType: '',
                    worksStatus: '',
                },
                createDate:null,
                // 排序
                checkboxGroup: {
                    radio1: '0',
                },
                current: 1,
                pageSize: 10,
                total: 0,
                // 时间区间
                startTime:"",
                endTime:"",
                // 活动名称
                activityList:[],
                activityUuid:"",
                activityWayUuid:"",
                activityWayList:"",
                typeUuid:"",
                typeList:[],
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
            getActivityInfo({activityStatus:"PREPARE,COLLECT,EVALUATE,FINISHED"}).then((res)=>{
                this.activityList = res;
            });
        },
        methods: {
            // 查询赛道信息
            chooseActivityWayInfo(){
                this.activityWayList = [];
                getActivityWayList({activityUuid:this.activityUuid}).then((res)=>{
                    this.activityWayList = res;
                });
            },
            // 查询类别信息
            getTypeInfo(){
                this.typeList = [];
                getActivityTypeList({activityWayUuid: this.activityWayUuid}).then((res) => {
                    this.typeList = res.data;
                });
            },
            getList(){
                //let year = this.createDate==null?null:this.createDate.getFullYear();
                //let month = this.createDate==null?null:this.createDate.getMonth() < 10?'0'+(this.createDate.getMonth() + 1):this.createDate.getMonth() + 1;
                //let date = this.createDate==null?null:this.createDate.getDate() < 10?'0'+this.createDate.getDate():this.createDate.getDate();
                let params = {
                    teamName:this.teamName,
                    name:this.worksName,
                    status:this.status,
                    //signDate:this.createDate==null?null : year+"-"+month+"-"+date,
                    signStartDate:this.startTime,
                    signEndDate:this.endTime,
                    current:this.current,
                    pageSize:this.pageSize,
                    orderBy:"status_descend",
                    activityUuid:this.activityUuid,
                    activityWayUuid:this.activityWayUuid,
                    typeUuid:this.typeUuid,
                };
                getWorksList(params).then((res)=>{
                    this.total = res.total;
                    this.tableData = res.list;
                });
            },
            resetData(){
                this.status = "";
                this.createDate = null;
                this.teamName = '';
                this.worksName = '';
                this.startTime = "";
                this.endTime = "";
                this.activityUuid = "";
                this.activityWayUuid = "";
                this.typeUuid = "";
                this.search();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
               this.current = 1;
                this.getList();
            },
            // // 审核
            examineMess(uuid,type){
                this.$refs.examineMessDialogRef.init(type,uuid);
            },
            // 时间格式
            chooseDate(){
                this.startTime = "";
                this.endTime = "";
                // 判断时间
                if(this.createDate!=null && this.createDate.length==2){
                    this.startTime = this.timeDate(this.createDate[0]);
                    this.endTime = this.timeDate(this.createDate[1]);
                }
            },
            timeDate(value){
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? "0" + MM : MM;
                let d = date.getDate();
                d = d < 10 ? "0" + d : d;
                return y + "-" + MM + "-" + d;
            }
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 20px;
        
                    /deep/ .el-input {
                        width: initial;
                        // margin-bottom: 22px;
                        margin-right: 30px;
                    }
        
                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;
            
                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }
        
                    /deep/ .el-input__prefix {
                        top: -3px;
                    }
        
                    /deep/ .el-input__suffix {
                        top: 2px;
                    }
        
                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }
        
                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }
        
                    .resetBtn {
                        color: #333333;
                    }
                    .searchItem {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        .name {
                            padding-right: 20px;
                            min-width: 100px;
                        }
                    }
                    .searchItem_time {
                        margin-right: 30px;
                        /deep/.el-input__inner {
                            width: 292px;
                        }
                    }
                }
                
                .tableContent {
                    min-height: 650px;
                    
                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }
                        
                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }
                    
                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }
                
                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
                .orderListTable {
                    margin-top: 35px;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;
                
                    i {
                        padding-right: 5px;
                    }
                
                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .sorting {
        p {
            margin: 0;
        }
        /deep/.el-radio-button--small .el-radio-button__inner {
           display: flex;
           align-items: center; 
        }
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            background-color: #3d7fff;
        }
    }
    .datainput{
        /deep/.el-range-input{
            font-size: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/workReviewList.vue